import React, { useCallback, useRef, useState } from 'react';

import { useTranslationX } from 'i18n';
import { FileUploader } from 'components/elements';
import { Dialog, DialogRef } from 'components/containers';

import { messageService } from 'services';
import { NotificationData } from '../../types';
import { useRequest } from 'apis';

import styles from './execution.module.scss';

type Props = {
  data: NotificationData;
  content: any;
  dispatch: any;
  onClose: (processed?: boolean) => void;
  reload: (data: NotificationData) => void;
};

const HiringDocsDialog = ({ data, content, onClose, reload }: Props) => {
  const dialog = useRef<DialogRef>(null);

  const { tx } = useTranslationX('request.form', 'project');
  const { tx: t3 } = useTranslationX('counterpartPanel', 'project');

  const getDocument = (documentName: string) => {
    const existsArchive =
      content[
        'doc' +
          documentName
            .split('_')
            .map(t => t.charAt(0).toUpperCase() + t.substr(1))
            .join('')
      ];
    return existsArchive ? documentName : '';
  };

  const [submittedArchive, setSubmittedArchive] = useState<string[]>([
    getDocument('autorizacao_polo'),
  ]);

  const request = useRequest();

  const handleSubmitArchives = useCallback(
    (files: File[], documentName: string) => {
      if (files.length === 0) {
        return;
      }
      const formData = new FormData();
      formData.set('file', files[0]);

      const source = request({
        method: 'POST',
        url: `/projeto/${content.projetoId}/recursos-humanos/${content.prhId}/documento/set_doc_${documentName}`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onSuccess: () => {
          const existsArchive =
            !!content[
              'doc' +
                documentName
                  .split('_')
                  .map(t => t.charAt(0).toUpperCase() + t.substr(1))
                  .join('')
            ];

          if (existsArchive) {
            messageService.success(
              tx('archiveSuccess', {
                documentName: tx(`documentsUpload.${documentName}`),
              }),
              {
                duration: 2000,
              }
            );
            reload(data);
            setSubmittedArchive(state => [...state, documentName]);
          }
        },
      });
      return () => source.cancel();
    },
    [content, request, tx, data, reload, setSubmittedArchive]
  );

  return (
    <Dialog
      ref={dialog}
      title={tx('title.upload-docs')}
      titleAlign="center"
      visible={!!data}
      onClose={onClose}
      onBlur={onClose}
      width={676}
    >
      <div className={styles.contentPopup}>
        <FileUploader
          message={t3('autorizacaoPolo')}
          metadata={{ rules: { accept: ['pdf'], maxfiles: 1, filesize: 5242880 } }}
          onChange={file => handleSubmitArchives(file, 'autorizacao_polo')}
          hasFilesUploaded={submittedArchive.includes('autorizacao_polo')}
          type="sneaky"
        />
      </div>
    </Dialog>
  );
};

export default HiringDocsDialog;
